import initialState from '../initialState.js';
import {
    GET_ACCOUNT_SUCCESS,
    GET_ACCOUNTS_SUCCESS,
    GET_REVIEW_ACCOUNTS_SUCCESS,
    UPDATE_ACCOUNT_SUCCESS,
    GET_PLAN_SUCCESS,
    UPDATE_PLAN_CLASS_RECORD,
    CREATE_ADMIN_SUCCESS,
    UPDATE_ADMIN_SUCCESS,
    REMOVE_ADMIN_SUCCESS,
    ADD_CENSUS_USER_SUCCESS,
    REMOVE_CENSUS_USER_SUCCESS,
    GET_USERS_SUCCESS,
    ADD_CLASS_SUCCESS,
    ADD_DESIGN_FOR_NEW_CLASS,
    EDIT_CLASS_SUCCESS,
    ADD_DIVISION_SUCCESS,
    EDIT_DIVISION_SUCCESS,
    UPDATE_CENSUS_USER_SUCCESS,
    UPDATE_CURRENT_ACCOUNT_META,
    REMOVE_NOTIFICATION_SUCCESS,
    SAVE_PRICING_INPUT,
    SAVE_TELUS_DRUG_PLAN_ID,
    SAVE_PLAN_DESIGN_BENEFIT_INIT_DATA,
    SAVE_PLAN_DESIGN_FIELD,
    REVERT_TO_PLAN_DESIGN_REVISION,
    SET_STATE,
    SAVE_MODULAR_BENEFIT_INIT_DATA,
    SAVE_MODULAR_FIELD,
    GET_CENSUS_SUCCESS,
    SET_ACCOUNT_LIVE,
    CREATE_NEW_PLAN_DESIGN,
    GET_REVISION_SUCCESS,
    SAVE_FULL_PLAN_DESIGN,
    SAVE_COMMISSIONS,
    UPDATE_REVISION_MODULAR_CLASSES
} from '../../actions/types/accounts';

export default (state = initialState.accounts, action) => {
    switch (action.type) {
        case SET_STATE: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            meta: {
                                ...state.currentAccount.revision.meta,
                                state: action.state
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    meta: {
                        ...state.currentAccount.meta,
                        state: action.state
                    }
                }
            };
        }

        case SET_ACCOUNT_LIVE: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    meta: {
                        ...state.currentAccount.meta,
                        status: 1,
                        state: 10
                    }
                }
            };
        }

        case GET_ACCOUNT_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    ...action.data
                }
            };
        }

        case GET_REVISION_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    revision: {
                        ...action.data
                    }
                }
            };
        }

        case GET_ACCOUNTS_SUCCESS: {
            const accounts = state.list ? [ ...state.list ] : [];

            return {
                ...state,
                list: action.shouldAppend ? [ ...accounts, ...action.accounts ] : [ ...action.accounts ],
                cursor: action.cursor
            };
        }

        case GET_REVIEW_ACCOUNTS_SUCCESS: {
            const accounts = state.forReview.list ? [ ...state.forReview.list ] : [];

            return {
                ...state,
                forReview: {
                    ...state.forReview,
                    list: action.shouldAppend ? [ ...accounts, ...action.accounts ] : [ ...action.accounts ],
                    cursor: action.cursor
                }
            };
        }

        case UPDATE_ACCOUNT_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    meta: { ...state.currentAccount.meta, ...action.body }
                }
            };
        }

        case SAVE_PRICING_INPUT: {
            if (action.revisionID) {
                const data = [ 'carrier', 'markup' ].indexOf(action.coverageType.toLowerCase()) !== -1 ?
                    action.data
                    :
                    {
                        [action.coverageType]: {
                            ...state.currentAccount.revision.planDesigns[action.classID][action.designID].pricing[action.benefit][action.coverageType],
                            ...action.data
                        }
                    };

                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            planDesigns: {
                                ...state.currentAccount.revision.planDesigns,
                                [action.classID]: {
                                    ...state.currentAccount.revision.planDesigns[action.classID],
                                    [action.designID]: {
                                        ...state.currentAccount.revision.planDesigns[action.classID][action.designID],
                                        pricing: {
                                            ...state.currentAccount.revision.planDesigns[action.classID][action.designID].pricing,
                                            [action.benefit]: {
                                                ...state.currentAccount.revision.planDesigns[action.classID][action.designID].pricing[action.benefit],
                                                ...data
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                };
            }

            const data = [ 'carrier', 'markup' ].indexOf(action.coverageType.toLowerCase()) !== -1 ?
                action.data
                :
                {
                    [action.coverageType]: {
                        ...state.currentAccount.designs[action.classID][action.designID].pricing[action.benefit][action.coverageType],
                        ...action.data
                    }
                };

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [action.classID]: {
                            ...state.currentAccount.designs[action.classID],
                            [action.designID]: {
                                ...state.currentAccount.designs[action.classID][action.designID],
                                pricing: {
                                    ...state.currentAccount.designs[action.classID][action.designID].pricing,
                                    [action.benefit]: {
                                        ...state.currentAccount.designs[action.classID][action.designID].pricing[action.benefit],
                                        ...data
                                    }
                                }
                            }
                        }
                    }
                }
            };
        }

        case SAVE_TELUS_DRUG_PLAN_ID: {
            const { classID, designID, telusDrugPlanID, revisionID } = action;

            if (revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            planDesigns: {
                                ...state.currentAccount.revision.planDesigns,
                                [classID]: {
                                    ...state.currentAccount.revision.planDesigns[classID],
                                    [designID]: {
                                        ...state.currentAccount.revision.planDesigns[classID][designID],
                                        telusDrugPlanID
                                    }
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [classID]: {
                            ...state.currentAccount.designs[classID],
                            [designID]: {
                                ...state.currentAccount.designs[classID][designID],
                                telusDrugPlanID
                            }
                        }
                    }
                }
            };
        }

        case SAVE_FULL_PLAN_DESIGN: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            planDesigns: {
                                ...state.currentAccount.revision.planDesigns,
                                [action.classID]: {
                                    ...state.currentAccount.revision.planDesigns[action.classID],
                                    [action.designID]: {
                                        ...state.currentAccount.revision.planDesigns[action.classID][action.designID],
                                        ...action.data
                                    }
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [action.classID]: {
                            ...state.currentAccount.designs[action.classID],
                            [action.designID]: {
                                ...state.currentAccount.designs[action.classID][action.designID],
                                ...action.data
                            }
                        }
                    }
                }
            };
        }

        case SAVE_PLAN_DESIGN_BENEFIT_INIT_DATA: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            planDesigns: {
                                ...state.currentAccount.revision.planDesigns,
                                [action.classID]: {
                                    ...state.currentAccount.revision.planDesigns[action.classID],
                                    [action.designID]: {
                                        ...state.currentAccount.revision.planDesigns[action.classID][action.designID],
                                        [action.benefit]: {
                                            ...action.data
                                        }
                                    }
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [action.classID]: {
                            ...state.currentAccount.designs[action.classID],
                            [action.designID]: {
                                ...state.currentAccount.designs[action.classID][action.designID],
                                [action.benefit]: {
                                    ...action.data
                                }
                            }
                        }
                    }
                }
            };
        }

        case SAVE_MODULAR_BENEFIT_INIT_DATA: {
            if (!action.tier) {
                if (action.revisionID) {
                    return {
                        ...state,
                        currentAccount: {
                            ...state.currentAccount,
                            revision: {
                                ...state.currentAccount.revision,
                                modularBlueprints: {
                                    ...state.currentAccount.revision.modularBlueprints,
                                    [action.classID]: {
                                        ...state.currentAccount.revision.modularBlueprints[action.classID],
                                        [action.benefit]: {
                                            ...action.data
                                        }
                                    }
                                }
                            }
                        }
                    };
                }

                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        modularBlueprints: {
                            ...state.currentAccount.modularBlueprints,
                            [action.classID]: {
                                ...state.currentAccount.modularBlueprints[action.classID],
                                [action.benefit]: {
                                    ...action.data
                                }
                            }
                        }
                    }
                };
            }

            if (action.tierBenefit === 'dental') {
                if (action.revisionID) {
                    return {
                        ...state,
                        currentAccount: {
                            ...state.currentAccount,
                            revision: {
                                ...state.currentAccount.revision,
                                modularBlueprints: {
                                    ...state.currentAccount.revision.modularBlueprints,
                                    [action.classID]: {
                                        ...state.currentAccount.revision.modularBlueprints[action.classID],
                                        dental: {
                                            ...state.currentAccount.revision.modularBlueprints[action.classID].dental,
                                            [action.tier]: {
                                                ...action.data
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    };
                }

                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        modularBlueprints: {
                            ...state.currentAccount.modularBlueprints,
                            [action.classID]: {
                                ...state.currentAccount.modularBlueprints[action.classID],
                                dental: {
                                    ...state.currentAccount.modularBlueprints[action.classID].dental,
                                    [action.tier]: {
                                        ...action.data
                                    }
                                }
                            }
                        }
                    }
                };
            }

            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            modularBlueprints: {
                                ...state.currentAccount.revision.modularBlueprints,
                                [action.classID]: {
                                    ...state.currentAccount.revision.modularBlueprints[action.classID],
                                    health: {
                                        ...state.currentAccount.revision.modularBlueprints[action.classID].health,
                                        [action.tier]: {
                                            ...state.currentAccount.revision.modularBlueprints[action.classID].health[action.tier],
                                            [action.benefit]: {
                                                ...action.data
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    modularBlueprints: {
                        ...state.currentAccount.modularBlueprints,
                        [action.classID]: {
                            ...state.currentAccount.modularBlueprints[action.classID],
                            health: {
                                ...state.currentAccount.modularBlueprints[action.classID].health,
                                [action.tier]: {
                                    ...state.currentAccount.modularBlueprints[action.classID].health[action.tier],
                                    [action.benefit]: {
                                        ...action.data
                                    }
                                }
                            }
                        }
                    }
                }
            };
        }

        case SAVE_MODULAR_FIELD: {
            if (!action.tier) {
                if (action.revisionID) {
                    return {
                        ...state,
                        currentAccount: {
                            ...state.currentAccount,
                            revision: {
                                ...state.currentAccount.revision,
                                modularBlueprints: {
                                    ...state.currentAccount.revision.modularBlueprints,
                                    [action.classID]: {
                                        ...state.currentAccount.revision.modularBlueprints[action.classID],
                                        [action.benefit]: {
                                            ...state.currentAccount.revision.modularBlueprints[action.classID][action.benefit],
                                            [action.field]: action.value
                                        }
                                    }
                                }
                            }
                        }
                    };
                }

                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        modularBlueprints: {
                            ...state.currentAccount.modularBlueprints,
                            [action.classID]: {
                                ...state.currentAccount.modularBlueprints[action.classID],
                                [action.benefit]: {
                                    ...state.currentAccount.modularBlueprints[action.classID][action.benefit],
                                    [action.field]: action.value
                                }
                            }
                        }
                    }
                };
            }

            if (action.tierBenefit === 'dental') {
                if (action.revisionID) {
                    return {
                        ...state,
                        currentAccount: {
                            ...state.currentAccount,
                            revision: {
                                ...state.currentAccount.revision,
                                modularBlueprints: {
                                    ...state.currentAccount.revision.modularBlueprints,
                                    [action.classID]: {
                                        ...state.currentAccount.revision.modularBlueprints[action.classID],
                                        dental: {
                                            ...state.currentAccount.revision.modularBlueprints[action.classID].dental,
                                            [action.tier]: {
                                                ...state.currentAccount.revision.modularBlueprints[action.classID].dental[action.tier],
                                                [action.field]: action.value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    };
                }

                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        modularBlueprints: {
                            ...state.currentAccount.modularBlueprints,
                            [action.classID]: {
                                ...state.currentAccount.modularBlueprints[action.classID],
                                dental: {
                                    ...state.currentAccount.modularBlueprints[action.classID].dental,
                                    [action.tier]: {
                                        ...state.currentAccount.modularBlueprints[action.classID].dental[action.tier],
                                        [action.field]: action.value
                                    }
                                }
                            }
                        }
                    }
                };
            }

            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            modularBlueprints: {
                                ...state.currentAccount.revision.modularBlueprints,
                                [action.classID]: {
                                    ...state.currentAccount.revision.modularBlueprints[action.classID],
                                    health: {
                                        ...state.currentAccount.revision.modularBlueprints[action.classID].health,
                                        [action.tier]: {
                                            ...state.currentAccount.revision.modularBlueprints[action.classID].health[action.tier],
                                            [action.benefit]: {
                                                ...state.currentAccount.revision.modularBlueprints[action.classID].health[action.tier][action.benefit],
                                                [action.field]: action.value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    modularBlueprints: {
                        ...state.currentAccount.modularBlueprints,
                        [action.classID]: {
                            ...state.currentAccount.modularBlueprints[action.classID],
                            health: {
                                ...state.currentAccount.modularBlueprints[action.classID].health,
                                [action.tier]: {
                                    ...state.currentAccount.modularBlueprints[action.classID].health[action.tier],
                                    [action.benefit]: {
                                        ...state.currentAccount.modularBlueprints[action.classID].health[action.tier][action.benefit],
                                        [action.field]: action.value
                                    }
                                }
                            }
                        }
                    }
                }
            };
        }

        case REVERT_TO_PLAN_DESIGN_REVISION: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [action.classID]: {
                            ...state.currentAccount.designs[action.classID],
                            [action.designID]: {
                                ...state.currentAccount.designs[action.classID][action.designID],
                                ...action.data
                            }
                        }
                    }
                }
            };
        }

        case GET_PLAN_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    plan: {
                        ...action.plan
                    }
                }
            };
        }

        case UPDATE_PLAN_CLASS_RECORD: {
            const { classID, key, type, value } = action.data;
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    plan: {
                        ...state.currentAccount.plan,
                        [classID]: {
                            ...state.currentAccount.plan[classID],
                            [key]: {
                                ...state.currentAccount.plan[classID][key],
                                [type]: Number(value)
                            }
                        }
                    }
                }
            };
        }

        case SAVE_PLAN_DESIGN_FIELD: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            planDesigns: {
                                ...state.currentAccount.revision.planDesigns,
                                [action.classID]: {
                                    ...state.currentAccount.revision.planDesigns[action.classID],
                                    [action.designID]: {
                                        ...state.currentAccount.revision.planDesigns[action.classID][action.designID],
                                        [action.benefit]: {
                                            ...state.currentAccount.revision.planDesigns[action.classID][action.designID][action.benefit],
                                            [action.field]: action.value
                                        }
                                    }
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [action.classID]: {
                            ...state.currentAccount.designs[action.classID],
                            [action.designID]: {
                                ...state.currentAccount.designs[action.classID][action.designID],
                                [action.benefit]: {
                                    ...state.currentAccount.designs[action.classID][action.designID][action.benefit],
                                    [action.field]: action.value
                                }
                            }
                        }
                    }
                }
            };
        }

        case CREATE_NEW_PLAN_DESIGN: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            planDesigns: {
                                ...state.currentAccount.revision.planDesigns,
                                [action.classID]: {
                                    ...state.currentAccount.revision.planDesigns[action.classID],
                                    [action.data.designID]: {
                                        ...action.data
                                    }
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [action.classID]: {
                            ...state.currentAccount.designs[action.classID],
                            [action.data.designID]: {
                                ...action.data
                            }
                        }
                    }
                }
            };
        }

        case CREATE_ADMIN_SUCCESS: {
            action.data.divisions = action.data.selectedDivisions;
            delete action.data.selectedDivisions;

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    admins: {
                        ...state.currentAccount.admins,
                        [action.data.adminID]: action.data
                    }
                }
            };
        }

        case UPDATE_ADMIN_SUCCESS: {
            action.data.divisions = action.data.selectedDivisions;
            delete action.data.selectedDivisions;

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    admins: {
                        ...state.currentAccount.admins,
                        [action.data.adminID]: {
                            ...state.currentAccount.admins[action.data.adminID],
                            ...action.data
                        }
                    }
                }
            };
        }

        case REMOVE_ADMIN_SUCCESS: {
            const copy = state.currentAccount.admins;
            delete copy[action.adminID];
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    admins: copy
                }
            };
        }

        case ADD_CENSUS_USER_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    employees: [ ...state.currentAccount.employees, action.data ]
                }
            };
        }

        case GET_CENSUS_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    employees: [ ...state.currentAccount.employees, ...action.users ]
                }
            };
        }

        case UPDATE_CENSUS_USER_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    employees: state.currentAccount.employees.map((employee) => {
                        if (employee.userID === action.data.userID) {
                            return {
                                ...employee,
                                ...action.data
                            };
                        }

                        return employee;
                    })
                }
            };
        }

        case REMOVE_CENSUS_USER_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    employees: state.currentAccount.employees.filter((item) => item.userID !== action.userID)
                }
            };
        }

        case GET_USERS_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    employees: action.users
                }
            };
        }

        case ADD_CLASS_SUCCESS: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            classes: {
                                ...state.currentAccount.revision.classes,
                                [action.data.classID]: action.data
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    classes: {
                        ...state.currentAccount.classes,
                        [action.data.classID]: action.data
                    }
                }
            };
        }


        case ADD_DESIGN_FOR_NEW_CLASS: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            planDesigns: {
                                ...state.currentAccount.revision.planDesigns,
                                [action.data.classID]: {}
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    designs: {
                        ...state.currentAccount.designs,
                        [action.data.classID]: {}
                    }
                }
            };
        }

        case EDIT_CLASS_SUCCESS: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            classes: {
                                ...state.currentAccount.revision.classes,
                                [action.data.classID]: {
                                    ...state.currentAccount.revision.classes[action.data.classID],
                                    title: action.data.title,
                                    description: action.data.description,
                                    earningsDefinition: action.data.earningsDefinition,
                                    hasBooklet: action.data.hasBooklet
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    classes: {
                        ...state.currentAccount.classes,
                        [action.data.classID]: {
                            ...state.currentAccount.classes[action.data.classID],
                            title: action.data.title,
                            description: action.data.description,
                            earningsDefinition: action.data.earningsDefinition,
                            hasBooklet: action.data.hasBooklet
                        }
                    }
                }
            };
        }

        case ADD_DIVISION_SUCCESS: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            divisions: {
                                ...state.currentAccount.revision.divisions,
                                [action.data.divisionID]: action.data
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    divisions: {
                        ...state.currentAccount.divisions,
                        [action.data.divisionID]: action.data
                    }
                }
            };
        }

        case EDIT_DIVISION_SUCCESS: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            divisions: {
                                ...state.currentAccount.revision.divisions,
                                [action.data.divisionID]: {
                                    ...state.currentAccount.revision.divisions[action.data.divisionID],
                                    title: action.data.title,
                                    description: action.data.description,
                                    address: action.data.address,
                                    hasBanking: action.data.hasBanking
                                }
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    divisions: {
                        ...state.currentAccount.divisions,
                        [action.data.divisionID]: {
                            ...state.currentAccount.divisions[action.data.divisionID],
                            title: action.data.title,
                            description: action.data.description,
                            address: action.data.address,
                            hasBanking: action.data.hasBanking
                        }
                    }
                }
            };
        }

        case UPDATE_CURRENT_ACCOUNT_META: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    meta: {
                        ...state.currentAccount.meta,
                        ...action.data
                    }
                }
            };
        }

        case REMOVE_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    notifications: state.currentAccount.notifications.filter((item) => item.id !== action.id)
                }
            };
        }

        case SAVE_COMMISSIONS: {
            if (action.revisionID) {
                return {
                    ...state,
                    currentAccount: {
                        ...state.currentAccount,
                        revision: {
                            ...state.currentAccount.revision,
                            commissions: {
                                ...action.commissions
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    commissions: {
                        ...action.commissions
                    }
                }
            };
        }

        case UPDATE_REVISION_MODULAR_CLASSES: {
            return {
                ...state,
                currentAccount: {
                    ...state.currentAccount,
                    revision: {
                        ...state.currentAccount.revision,
                        classes: {
                            ...action.classes
                        },
                        planDesigns: {
                            ...action.planDesigns
                        }

                    }
                }
            };
        }

        default:
            return state;
    }
};